import React from 'react';
import { Text } from '@mantine/core';
import { modals } from '@mantine/modals';

interface ConfirmDialogOptions {
  name: string;
  message: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

export function openConfirmDialog({
  name,
  message,
  onConfirm,
  onCancel,
}: ConfirmDialogOptions): void {
  modals.openConfirmModal({
    title: name,
    children: <Text size="sm">{message}</Text>,
    labels: { confirm: 'Confirm', cancel: 'Cancel' },
    confirmProps: { color: 'red', 'data-cy': 'confirm-dialog-confirm' },
    cancelProps: { 'data-cy': 'confirm-dialog-cancel' },
    onConfirm,
    onCancel,
  });
}
